var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"background":"#fafafa"},attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs10":"","sm10":"","md10":""}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }